import { render } from "./TransportOffersForm.vue?vue&type=template&id=64d387d0"
import script from "./TransportOffersForm.vue?vue&type=script&lang=js"
export * from "./TransportOffersForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__